import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative py-12 px-4 sm:px-6 lg:px-8 bg-background border-t border-text-primary/10">
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-text-primary/70 text-sm">
              © {currentYear} Peyton Clark. All rights reserved.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-text-primary/70 hover:text-accent text-sm transition-colors touch-manipulation"
            >
              Home
            </Link>
            <Link
              to="/#about"
              className="text-text-primary/70 hover:text-accent text-sm transition-colors touch-manipulation"
            >
              About
            </Link>
            <Link
              to="/#projects"
              className="text-text-primary/70 hover:text-accent text-sm transition-colors touch-manipulation"
            >
              Projects
            </Link>
            <Link
              to="/#contact"
              className="text-text-primary/70 hover:text-accent text-sm transition-colors touch-manipulation"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

